import React from 'react';
import _ from 'lodash';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import { SnackbarProvider } from 'notistack';
import { I18nProvider } from '@lingui/react';
import { ApolloProvider } from '@apollo/client';
import { DndProvider } from 'react-dnd';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ActionCableProvider } from '../../context/ActionCableContext';
import { ApolloCableProvider } from '../../context/ApolloCableContext';
import { BookmarksProvider } from '../../context/BookmarksContext';
import { GlobalSearchProvider } from '../../context/GlobalSearchContext';
import { SettingsProvider } from '../../context/SettingsContext';
import { restoreSettings } from '../../shared/libs/settings';
import { sendError } from '../../shared/libs/logger';
import { Error500 } from '../../core/components/Error500';
import createTheme from '../setup/theme';
import catalogEn from '../../locale/en/messages';
import { FeatureFlagProvider } from '../../shared/contexts/FeatureFlagContext';

const catalogs = { en: catalogEn };
const settings = restoreSettings();

export default (
  createStore,
  createApolloClient,
  AppContent
) => async serverData => {
  const { props } = serverData;
  const store = await createStore({ ...props });
  const apolloClient = await createApolloClient({
    ...props,
    onError: errs => store.dispatch({ type: 'apollo.error', ...errs }),
  });
  const subdomain = _.get(props, ['company', 'subdomain']);
  const ThemeProvider = await createTheme(subdomain);

  const errorHandler = (error, componentStack) => {
    console.log('error')
    sendError(error, componentStack, store.getState());
  };
  
  return (
    <ErrorBoundary FallbackComponent={Error500} onError={errorHandler}>
      <SnackbarProvider maxSnack={3}>
        <Provider store={store}>
          <ApolloProvider client={apolloClient}>
            <SettingsProvider settings={settings}>
              <ThemeProvider>
                <I18nProvider language="en" catalogs={catalogs}>
                  <ActionCableProvider>
                    <ApolloCableProvider>
                      <DndProvider backend={HTML5Backend}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <BookmarksProvider>
                            <GlobalSearchProvider>
                              <FeatureFlagProvider>
                                <AppContent store={store} />
                              </FeatureFlagProvider>
                            </GlobalSearchProvider>
                          </BookmarksProvider>
                        </LocalizationProvider>
                      </DndProvider>
                    </ApolloCableProvider>
                  </ActionCableProvider>
                </I18nProvider>
              </ThemeProvider>
            </SettingsProvider>
          </ApolloProvider>
        </Provider>
      </SnackbarProvider>
    </ErrorBoundary>
  );
};
